export enum StaticResourceTypes {
  All = 'All',
}